import CardComponent from "./CardComponent";

export class ButtonRequestQuote extends CardComponent {

}
